import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "mute-secondary": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      size: "medium",
      stripe: "",
      data: _ctx.invitations,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "#",
          width: "60"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: scope.row._id
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", {
                  "f-w-700": "",
                  class: "el-icon-position"
                }, null, -1)
              ]))]),
              _: 1
            }, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Type",
          width: "270"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: 
              scope.row.type === 'admin'
                ? 'danger'
                : scope.row.type === 'talent'
                ? 'info'
                : 'success'
            ,
              effect: "dark",
              "is-rounded": "",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.type)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "Status",
          width: "270"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: 
              scope.row.status === 'accepted'
                ? 'success'
                : scope.row.status === 'denied'
                ? 'danger'
                : 'info'
            ,
              effect: "dark",
              "is-rounded": "",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$filters.capitalize(scope.row.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Email",
          width: "350"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_link, {
              type: "primary",
              href: `mailto:${scope.row.email}`,
              size: "mini"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.email), 1)
              ]),
              _: 2
            }, 1032, ["href"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Created At",
          align: "left",
          width: "250"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("small", _hoisted_1, _toDisplayString(_ctx.$filters.capitalize(_ctx.$moment(scope.row.createdAt).fromNow())), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "..."
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "el-icon-delete",
              size: "mini"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}